// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Hooks from "../../utils/Hooks.bs.jsx";
import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import HeaderModuleCss from "./Header.module.css";

let classes = HeaderModuleCss;

function Header(props) {
  let headerRef = React.useRef(null);
  let layout = Hooks.useIsHorizontallyOverflowing(headerRef.current, [
    `xl`,
    `sm`
  ]);
  return React.cloneElement(<header
    ref={Primitive_option.some(headerRef)}
    className={classes.root + ` ` + Stdlib_Option.getOr(props.className, "")}
  >
    <h2>
      {props.headingSlot}
    </h2>
    <p>
      {props.subheadingSlot}
    </p>
    {props.buttonLeftSlot}
    {props.buttonRightSlot}
  </header>, {
    "data-layout": layout
  });
}

let make = Header;

export {
  classes,
  make,
}
/* classes Not a pure module */
